import { Box, Typography } from '@mui/material';
import DOMPurify from 'dompurify';

import { Section, SectionCard, SectionHeader } from '@/components/common';
import type { TcRunAppraiseeResponse } from '@/api/types/tcRun.types';

interface NotesToTcSectionProps {
  appraisee: TcRunAppraiseeResponse;
}

export function NotesToTcSection({ appraisee }: NotesToTcSectionProps) {
  const html = appraisee.notesToTalentCommittee;

  if (!html) {
    return (
      <Section>
        <SectionHeader>NOTES TO TALENT COMMITTEE</SectionHeader>
        <SectionCard>
          <Typography variant="body2" color="text.secondary">
            No notes to talent committee.
          </Typography>
        </SectionCard>
      </Section>
    );
  }

  return (
    <Section>
      <SectionHeader>NOTES TO TALENT COMMITTEE</SectionHeader>
      <SectionCard>
        <Box
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html) }}
          sx={{ '& p': { my: 0.5 } }}
        />
      </SectionCard>
    </Section>
  );
}
